import React from 'react';
import PropTypes from 'prop-types';
import PageLoaderWithTryAgain from '@client/components/pageLoader/PageLoaderWithTryAgain';
import styles from './loader.scss';

function Loader({ className }) {
  return <PageLoaderWithTryAgain className={styles.loader} tryAgain={false} />;
}

Loader.propTypes = {
  className: PropTypes.string,
};

export default Loader;
